<template>
  <template v-if="props.element.nodeType === 3">
    {{ props.element.text }}
  </template>

  <component v-else-if="component" :is="component" v-bind="props.element.attributes">
    <MoleculesBlocksInfoPageElement v-for="element in props.element.childNodes" :element="element" />
  </component>

  <template v-else>
    <MoleculesBlocksInfoPageElement v-for="element in props.element.childNodes" :element="element" />
  </template>
</template>
<script setup>

const props = defineProps({
  element: Object
});

const component = computed(() => {

  let result = props.element.tagName?.toLowerCase();

  switch (props.element.tagName?.toLowerCase()) {
    case 'dynamicky-doplnene-nejoblibenejsi-znacky':
      result = resolveComponent('MoleculesDynamicMostPopularVendors');
      break;
    case 'dynamicky-doplnene-nove-znacky':
      result = resolveComponent('MoleculesDynamicNewVendors');
      break;
    case 'dynamicky-doplnene-vsechny-znacky':
      result = resolveComponent('MoleculesDynamicAllVendors');
      break;
    case 'hledaci-policko':
      result = resolveComponent('MoleculesDynamicOrderSearchField');
      break;
    case 'branch-opening':
      result = resolveComponent('MoleculesDynamicBranchOpening');
      break
    case 'photogallery':
      result = resolveComponent('MoleculesDynamicPhotogallery');
      break
    case 'cenik-dopravy':
      result = resolveComponent('MoleculesDynamicShippingPricelist');
      break
    case 'youtube-video':
      result = resolveComponent('MoleculesDynamicYouTubeVideo');
      break;
    case 'custom-heading':
      result = resolveComponent('AtomsTextHeading');
      break;
    case 'performance-meter':
      result = resolveComponent('MoleculesDynamicPerformanceMeter');
      break;
    case 'map':
      result = resolveComponent('MoleculesGlobalMap');
      break;
  }

  return result;
});

if (props.element.attributes?.name) {
  props.element.attributes['data-anchor'] = props.element.attributes.name;
}

const elementType = props.element.tagName?.toLowerCase();

</script>